import { prefetchIllustrations } from '@utils/illustrationCache'

/** @import { OfferDataPayload } from '../../types.js' */

const WORKER_URL = 'https://bio-scraper.albertsmit.workers.dev'
const DATA_URL = '/data/offers.json'

async function fetchFromSources(sources) {
  for (const url of sources) {
    try {
      const response = await fetch(url)
      if (response.ok) return response
    } catch {
      // try next source
    }
  }
  return null
}

export function dataSlice(set, get) {
  return {
    /** @type {OfferDataPayload|null} */
    rawData: null,
    loading: true,
    /** @type {string|null} */
    error: null,

    fetchOffers: async () => {
      set({ loading: true, error: null })
      try {
        const response = await fetchFromSources([WORKER_URL, '/api/v1/offers', DATA_URL])
        if (!response) throw new Error('Fout bij ophalen data: geen verbinding')
        const data = await response.json()
        set({ rawData: data, loading: false })

        // Warm the illustration cache for all offers that have illustrations
        const illustrationUrls = (data.offers ?? [])
          .map((o) => o.illustrationUrl)
          .filter(Boolean)
        if (illustrationUrls.length > 0) prefetchIllustrations(illustrationUrls)

        // If Premium was previously enabled (from localStorage), load the catalog too
        if (get().hasAHPremium && !get().catalog) get().fetchCatalog()
      } catch (err) {
        set({ error: err.message, loading: false })
      }
    },
  }
}
